<template>
  <div v-click-outside="outClose">
    <div class="floating-wrapper">
      <input
        class="input-main"
        type="search"
        @click="
          openMenu = !openMenu;
          showItemsCount = false;
        "
        @blur="
          selectedItems.length > 0 && searchTagQuery.length === 0
            ? (showItemsCount = true)
            : (showItemsCount = false)
        "
        @focus="showItemsCount = false"
        :placeholder="'Users'"
        v-model="searchTagQuery"
      />
      <span
        @click="showItemsCount = false"
        v-if="showItemsCount && !showOtherFilteringNumber"
        class="selsected-count"
      >
        {{ selectedItems.length }} +
      </span>
    </div>
    <div class="root" v-if="showResults || openMenu">
      <input
        type="checkbox"
        class="all-checkbox"
        @click="checkSelectAll"
        :checked="selectAll"
        id="check-all"
      />
      <label class="label-check-all" for="check-all">All </label>
      <input type="checkbox" class="item-checkbox" :value="opt" id="exclude" />
      <label class="item-text" for="exclude">Exclusion</label>
      <div class="dropdown-divider"></div>

      <div class="scroller-div" v-on:scroll="fetchStats">
        <div v-if="showResults">
          <ul>
            <li v-for="(opt, idx) in result" :key="idx">
              <input
                type="checkbox"
                class="item-checkbox"
                v-model="selectedItems"
                :value="opt"
                :id="opt.id"
              />
              <label class="item-text" :for="opt.id"
                >{{ opt.full_name | truncate(11) }}
                <span class="item-counter">- {{ getStats(opt.id).count }}</span>
              </label>
            </li>
          </ul>
        </div>
        <div v-if="openMenu && !showResults">
          <ul>
            <li v-for="(opt, idx) in filterOptions()" :key="idx">
              <input
                type="checkbox"
                class="item-checkbox"
                v-model="selectedItems"
                :value="opt"
                :id="opt.id"
              />
              <label class="item-text" :for="opt.id"
                >{{ opt.full_name | truncate(11) }}
                <span class="item-counter">- {{ getStats(opt.id).count }}</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
      <!--      fas fa-times
      fas fa-sync-->
      <div class="tag-form-btns">
        <a
          class="tag-form-cancel-btn"
          href="javascript:void(0)"
          @click.prevent="closeSelect"
          ><span class="fas fa-times"></span
        ></a>

        <div class="loader-bottom">
          <loader v-if="requestAssignBusy" :size="'3px'"></loader>
        </div>
        <a
          class="tag-form-ok-btn"
          href="javascript:void(0)"
          @click.prevent="resetSelect"
          ><span class="fas fa-sync"></span
        ></a>
      </div>
    </div>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
import apiClientCreator from "../../../../helpers/api/request";
import { mapGetters } from "vuex";
import Loader from "../../../../main/misc.main/loader/Loader";
export default {
  name: "MultiSelect.component",
  components: { Loader },
  props: {
    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isAllowed: {
      type: Boolean
    },
    queryObject: {
      type: Object
    },

    options: {
      type: Array,
      required: true,
      default: () => []
    },
    resetList: {
      type: Boolean,
      required: false
    },
    otherFiltering: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
  },

  data() {
    return {
      selectedItems: [],
      infoData: [],
      openMenu: false,
      showResults: false,
      searchTagQuery: "",
      result: [],
      selectAll: false,
      showItemsCount: false,
      showOtherFilteringNumber: true,
      assignStats: [],
      requestAssignBusy: false
    };
  },

  watch: {
    searchTagQuery: function() {
      this.fetchStats();
      if (this.selectedItems.length > 0 && this.searchTagQuery.length === 0) {
        this.showItemsCount = true;
      } else {
        this.showItemsCount = false;
      }
      if (this.selectedItems.length === 0 && this.searchTagQuery.length === 0) {
        this.showOtherFilteringNumber = true;
      } else {
        this.showOtherFilteringNumber = false;
      }
      this.result = this.filterList(this.searchTagQuery);

      if (this.result.length > 0) {
        this.fetchStats(); ///////////////////////////////
        this.showResults = true;
      }
      if (this.searchTagQuery === "") {
        this.showResults = false;
        this.result = []; //////////////
        this.assignStats = []; //////////////
      }
    },
    resetList: function() {
      if (this.resetList === true) {
        this.selectedItems = [];
        this.selectAll = false;
        this.assignStats = []; /////////////////////////////////
      }
    },
    selectedItems: function() {
      if (this.selectedItems.length > 0 && this.searchTagQuery.length === 0) {
        this.showItemsCount = true;
      } else {
        this.showItemsCount = false;
      }
      // if (this.selectedItems.length === 0) {
      //this.selectedItems = [];
      //this.$emit("reset");
      // }
    },
    openMenu: function() {
      if (this.openMenu) {
        this.assignStats = [];
        this.fetchStats();
        //  this.filterOptions()
      }
    },
    initiatedFiltering() {
      if (this.initiatedFiltering && this.assignStats.length > 0) {
        this.assignStats = [];
      }
    }
  },

  methods: {
    fetchStats() {
      if (
        !this.requestAssignBusy &&
        this.assignStats.length < this.options.length
      ) {
        this.requestAssignBusy = true;

        // let id;
        // if (this.result.length > 0) {
        //   id = this.result[0].id;
        //   this.assignStats = [];
        // } else {
        //   id = this.assignStats.length;
        // }
        // =startFrom.length>0 ?  :

        apiClientCreator(`tasks/stats/ms/users/`)
          .get("", { params: this.queryObject })
          .then(res => {
            ///   res.data.map(item => {
            this.assignStats = res.data; //.push(item);
            ///  });

            this.requestAssignBusy = false;
            //this.fetchStats();
          })
          .catch(err => {
            this.requestAssignBusy = false;
          });
      }
    },
    filterOptions() {
      // if( this.statsData1.length>0) {
      return this.options.filter(item => this.getStats(item.id).count !== 0);
      // }
      // return [];
    },
    getStats(i) {
      const stat = this.assignStats.find(item => item.user_id === i);
      if (stat === undefined) {
        return { count: "load..." };
      }
      return stat;
    },
    outClose() {
      if (this.openMenu === true) {
        this.$emit("input", this.selectedItems);
        this.closeSelect();
      }
    },
    checkSelectAll: function() {
      this.selectedItems = [];
      let person;
      if (!this.selectAll) {
        for (person in this.options) {
          this.selectedItems.push(this.options[person]);
        }
      }
      this.selectAll = !this.selectAll;
    },

    closeSelect() {
      this.searchTagQuery = "";
      this.showResults = false;
      this.openMenu = false;
    },
    resetSelect() {
      this.selectedItems = [];
      this.selectAll = false;
      this.$emit("input", this.selectedItems);
      this.$emit("reset");
      this.closeSelect();
    },

    filterList(q) {
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      return this.options.filter(item => {
        return searchRegex.test(item.full_name);
      });
    }
  }
};
</script>

<style scoped>
.floating-wrapper {
  position: relative;
}
.selsected-count {
  position: absolute;
  top: 8px;
  left: 5px;
  background: white;
  font-size: 8pt;
  height: 20px;
  width: 90%;
}
.root {
  position: absolute;
  top: 30px;
  left: 0px;
  width: max-content;
  min-width: 126px;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 5px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.scroller-div {
  height: auto;
  max-height: 200px;
  overflow-x: hidden;
}
ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
}

li:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.item-text {
  vertical-align: middle;
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
  cursor: pointer;
}
.item-checkbox {
  vertical-align: middle;
  margin-bottom: 4px;
  margin-right: 5px;
}
.item-counter {
  font-size: 8pt;
  font-weight: bolder !important;
  margin-left: 10px;
  /*  float: right;
  margin-top: 5px;*/
}

.tag-form-cancel-btn {
  color: red !important;
  float: right;
  margin-right: 5px;
  margin-top: 5px;
}

.tag-form-ok-btn {
  color: green !important;
  float: left;
  margin-left: 5px;
  margin-top: 5px;
}
.input-main {
  width: 117px;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 117px;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}
input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /*padding: 3px 0px 3px 3px;*/
  border: 1px solid rgba(81, 203, 238, 1);
}
.label-check-all {
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
  cursor: pointer;
  margin-right: 20px;
}
.all-checkbox {
  vertical-align: middle;
  margin-bottom: 5px;
  margin-right: 5px;
  text-align: left;
}
.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.sum-of-items {
  font-size: 12px;
}

.loader-bottom {
  position: absolute;
  bottom: -5px;
  left: 50%;
}
</style>
